(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["howl-exact-product-gallery"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('howl-exact-gallery')) {
    customElements.define('howl-exact-gallery', class extends HTMLElement {
      connectedCallback() {
        this.abort?.abort();
        this.abort = new AbortController();
        this.viewport = this.querySelector('.howl-exact-gallery__viewport');
        this.panels = [...this.querySelectorAll('.howl-exact-gallery__panel')];
        this.thumbnails = [...this.querySelectorAll('.howl-exact-gallery__thumbnail')];
        this.status = this.querySelector('[data-gallery-status]');
        this.index = 0;
        this.viewportWidth = this.viewport.clientWidth;
        this.resizeObserver?.disconnect();
        this.resizeObserver = new ResizeObserver(() => {
          const width = this.viewport.clientWidth;
          if (!width || width === this.viewportWidth) return;
          this.viewportWidth = width;
          cancelAnimationFrame(this.scrollFrame);
          this.viewport.scrollTo({ left: this.panels[this.index].offsetLeft - this.panels[0].offsetLeft, behavior: 'instant' });
        });
        this.resizeObserver.observe(this.viewport);
        const options = { signal: this.abort.signal };
        this.querySelector('[data-gallery-previous]').addEventListener('click', () => this.show((this.index + this.panels.length - 1) % this.panels.length), options);
        this.querySelector('[data-gallery-next]').addEventListener('click', () => this.show((this.index + 1) % this.panels.length), options);
        this.thumbnails.forEach((thumbnail, index) => {
          thumbnail.addEventListener('click', (event) => {
            event.preventDefault();
            this.show(index);
          }, options);
        });
        this.addEventListener('keydown', (event) => {
          if (event.target !== this.viewport && !this.thumbnails.includes(event.target)) return;
          let index;
          if (event.key === 'ArrowRight') index = (this.index + 1) % this.panels.length;
          else if (event.key === 'ArrowLeft') index = (this.index + this.panels.length - 1) % this.panels.length;
          else if (event.key === 'Home') index = 0;
          else if (event.key === 'End') index = this.panels.length - 1;
          else return;
          event.preventDefault();
          this.show(index);
          if (event.target !== this.viewport) this.thumbnails[index].focus({ preventScroll: true });
        }, options);
        this.viewport.addEventListener('scroll', () => {
          cancelAnimationFrame(this.scrollFrame);
          this.scrollFrame = requestAnimationFrame(() => {
            const index = Math.round(this.viewport.scrollLeft / this.viewport.clientWidth);
            this.select(Math.min(this.panels.length - 1, Math.max(0, index)));
          });
        }, { ...options, passive: true });
      }

      show(index) {
        this.select(index);
        this.viewport.scrollTo({
          left: this.panels[index].offsetLeft - this.panels[0].offsetLeft,
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }

      select(index) {
        if (index === this.index) return;
        this.index = index;
        this.querySelector('[data-gallery-counter]').textContent = `${index + 1} / ${this.panels.length}`;
        const strip = this.querySelector('.howl-exact-gallery__thumbnails');
        const thumb = this.thumbnails[index];
        if (thumb.offsetLeft < strip.scrollLeft || thumb.offsetLeft + thumb.offsetWidth > strip.scrollLeft + strip.clientWidth) {
          strip.scrollTo({ left: thumb.offsetLeft - strip.offsetLeft - (strip.clientWidth - thumb.offsetWidth) / 2, behavior: 'auto' });
        }
        this.thumbnails.forEach((thumbnail, position) => {
          if (position === index) thumbnail.setAttribute('aria-current', 'true');
          else thumbnail.removeAttribute('aria-current');
        });
        this.status.textContent = this.dataset.statusTemplate.replace('[index]', String(index + 1));
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        this.abort?.abort();
        cancelAnimationFrame(this.scrollFrame);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["howl-four-picture-banner"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('howl-picture-banner'))customElements.define('howl-picture-banner',class extends HTMLElement{
    connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
      this.slides=[...this.querySelectorAll('[data-banner-slide]')];this.dots=[...this.querySelectorAll('[data-banner-dot]')];this.index=0;this.inView=false;this.hovering=false;this.engaged=false;
      this.motion=matchMedia('(prefers-reduced-motion:reduce)');this.paused=this.motion.matches;
      this.request=(this.request||0)+1;
      this.loadSlide(0).then(()=>{if(!options.signal.aborted)requestAnimationFrame(()=>{if(!options.signal.aborted)this.slides.slice(2).forEach((slide,i)=>this.loadSlide(i+2))})});
      this.status=this.querySelector('[data-banner-status]');
      this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.show(i,true),options));
      this.addEventListener('keydown',event=>{if(event.target!==this.querySelector('.howl-picture-banner__stage'))return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();this.show(this.index+(event.key==='ArrowRight'?1:-1),true)}},options);
      this.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'){this.engaged=true;this.hovering=true;this.schedule()}},options);
      this.addEventListener('pointerleave',()=>{this.hovering=false;this.schedule()},options);
      this.addEventListener('focusin',()=>{this.engaged=true;this.schedule()},options);this.addEventListener('focusout',()=>queueMicrotask(()=>{this.schedule()}),options);
      this.addEventListener('pointerdown',event=>{this.engaged=true;if(event.pointerType==='touch')this.touch={x:event.clientX,y:event.clientY}},options);
      this.addEventListener('pointerup',event=>{if(!this.touch)return;const x=event.clientX-this.touch.x,y=event.clientY-this.touch.y;this.touch=null;if(Math.abs(x)>45&&Math.abs(x)>Math.abs(y))this.show(this.index+(x<0?1:-1),true);else this.schedule()},options);
      this.addEventListener('pointercancel',()=>{this.touch=null},options);
      document.addEventListener('visibilitychange',()=>this.schedule(),options);
      this.motion.addEventListener('change',()=>{if(this.motion.matches)this.paused=true;this.schedule()},options);
      this.observer=new IntersectionObserver(entries=>{this.inView=entries[0].isIntersecting;this.schedule()},{threshold:.3});this.observer.observe(this);
    }
    loadSlide(index){
      const slide=this.slides[index],image=slide.querySelector('img');
      image.loading='eager';
      slide.querySelectorAll('source[data-srcset]').forEach(source=>{source.srcset=source.dataset.srcset;delete source.dataset.srcset});
      if(image.dataset.src){image.loading='eager';image.src=image.dataset.src;delete image.dataset.src}
      if(image.complete&&image.naturalWidth)return Promise.resolve(true);
      return image.decode().then(()=>true,()=>false);
    }
    async show(index,manual=false){
      const requested=++this.request,target=(index+this.slides.length)%this.slides.length;
      if(manual)this.paused=true;
      if(!await this.loadSlide(target)){this.schedule();return}
      if(requested!==this.request||!this.isConnected)return;
      this.index=target;
      this.slides.forEach((slide,i)=>{slide.classList.toggle('is-active',i===this.index);slide.setAttribute('aria-hidden',String(i!==this.index))});
      this.dots.forEach((dot,i)=>{if(i===this.index)dot.setAttribute('aria-current','true');else dot.removeAttribute('aria-current')});
      if(manual){this.paused=true;this.status.textContent=this.status.dataset.template.replace('[index]',this.index+1).replace('[total]',this.slides.length)}
      this.schedule();
    }
    schedule(){clearTimeout(this.timer);if(this.slides.length<2||!this.isConnected||this.paused||!this.inView||this.hovering||document.hidden||this.contains(document.activeElement))return;this.timer=setTimeout(()=>this.show(this.index+1),3000)}
    disconnectedCallback(){this.request++;this.abort?.abort();this.observer?.disconnect();clearTimeout(this.timer)}
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["howl-react-product-card"] && !Shopify.designMode) return;
  try {
    const loadHowlHover = (link) => {
    const template = link?.querySelector('template[data-howl-hover]');
    if (!template) return;
    const image = template.content.querySelector('img')?.cloneNode(true);
    template.remove();
    if (!image) return;
    image.loading = 'eager';
    image.fetchPriority = 'low';
    link.append(image);
    image.decode().then(() => image.setAttribute('data-howl-ready', '')).catch(() => image.remove());
  };
  document.addEventListener('pointerover', event => {
    if (event.pointerType === 'mouse' && matchMedia('(hover: hover)').matches) loadHowlHover(event.target.closest('.howl-native-card__media'));
  });
  document.addEventListener('focusin', event => {
    const link = event.target.closest('.howl-native-card__media');
    if (link?.matches(':focus-visible')) loadHowlHover(link);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["howl-shipping-progress"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('howl-shipping-progress')) {
    const previousBoxes = new Map();
    customElements.define('howl-shipping-progress', class extends HTMLElement {
      connectedCallback() {
        this.context = this.closest('cart-drawer') ? 'drawer' : 'page';
        const previous = previousBoxes.get(this.context);
        this.progress = Math.min(100, Math.max(0, Number(this.dataset.progress) || 0));
        this.message = this.querySelector('p');
        this.finalMessage = this.message.textContent;
        this.fill = this.querySelector('.howl-shipping-progress__track span');
        previousBoxes.set(this.context, { progress: this.progress, message: this.finalMessage });
        this.drawer = this.closest('cart-drawer');
        this.motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
        this.abort = new AbortController();
        this.sync = () => this.syncCelebration();
        this.observer = new IntersectionObserver(entries => {
          this.inView = entries[0].isIntersecting;
          this.sync();
        }, { threshold: 0 });
        this.observer.observe(this);
        if (this.drawer) {
          this.drawerObserver = new MutationObserver(this.sync);
          this.drawerObserver.observe(this.drawer, { attributes: true, attributeFilter: ['class'] });
        }
        document.addEventListener('visibilitychange', this.sync, { signal: this.abort.signal });
        this.motionPreference.addEventListener('change', this.sync, { signal: this.abort.signal });
        const reduced = this.motionPreference.matches;
        if (!previous || previous.progress === this.progress || reduced) return;
        const unlocked = previous.progress < 100 && this.progress === 100;
        if (unlocked) {
          this.message.textContent = previous.message;
          this.classList.remove('howl-shipping-progress--complete');
        }
        this.filling = true;
        this.motion = this.fill.animate([
          { transform: `scaleX(${previous.progress / 100})` },
          { transform: `scaleX(${this.progress / 100})` }
        ], { duration: 600, easing: 'cubic-bezier(.22,1,.36,1)' });
        this.motion.onfinish = () => {
          if (!this.isConnected) return;
          this.message.textContent = this.finalMessage;
          this.classList.toggle('howl-shipping-progress--complete', this.progress === 100);
          this.filling = false;
          this.sync();
        };
      }
      disconnectedCallback() {
        if (this.motion) this.motion.cancel();
        this.stopCelebration();
        this.observer?.disconnect();
        this.drawerObserver?.disconnect();
        this.abort?.abort();
        // Section replacements reconnect synchronously; an empty cart clears history.
        queueMicrotask(() => {
          const replacement = [...document.querySelectorAll('howl-shipping-progress')]
            .some(node => node.context === this.context);
          if (!replacement) previousBoxes.delete(this.context);
        });
      }
      stopCelebration() {
        clearTimeout(this.celebrationTimer);
        this.celebrationTimer = null;
        this.confetti?.getAnimations({ subtree: true }).forEach(animation => animation.cancel());
        this.confetti?.remove();
      }
      syncCelebration() {
        const visible = this.isConnected && this.inView && !document.hidden &&
          (!this.drawer || this.drawer.classList.contains('active'));
        if (!visible || this.progress < 100 || this.motionPreference.matches || this.filling) {
          this.stopCelebration();
          return;
        }
        if (this.celebrationTimer) return;
        this.celebrate();
        this.celebrationTimer = setTimeout(() => {
          this.celebrationTimer = null;
          this.syncCelebration();
        }, 3200);
      }
      celebrate() {
        const layer = document.createElement('span');
        layer.className = 'howl-shipping-confetti';
        layer.setAttribute('aria-hidden', 'true');
        this.confetti = layer;
        this.append(layer);
        const width = this.clientWidth;
        for (let i = 0; i < 24; i++) {
          const bit = document.createElement('i');
          const right = i % 2;
          bit.style.cssText = `left:${right ? '94%' : '6%'};background:${['#27503a', '#b89b62', '#d8c6a0'][i % 3]}`;
          layer.append(bit);
          const x = (right ? -1 : 1) * width * (.08 + Math.random() * .32);
          const spin = (Math.random() - .5) * 540;
          const motion = bit.animate([
            { transform: 'translate(0,0) rotate(0deg)', opacity: 0 },
            { transform: `translate(${x * .6}px,-${35 + Math.random() * 50}px) rotate(${spin / 2}deg)`, opacity: 1, offset: .35 },
            { transform: `translate(${x}px,70px) rotate(${spin}deg)`, opacity: 0 }
          ], { duration: 3000, delay: (i % 4) * 25, easing: 'ease-out' });
          motion.onfinish = () => { bit.remove(); if (!layer.childElementCount) layer.remove(); };
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["howl-sticky-purchase"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('howl-sticky-purchase')) {
    customElements.define('howl-sticky-purchase', class extends HTMLElement {
      connectedCallback() {
        this.target = document.getElementById(this.dataset.target);
        if (!this.target) return;
        this.button = this.querySelector('button');
        this.activate = () => {
          this.target.click();

        };
        this.button.addEventListener('click', this.activate);
        this.sync = () => {
          const current = document.getElementById(this.dataset.target);
          if (!current) { this.hidden = true; return; }
          this.target = current;
          this.button.disabled = current.disabled || current.getAttribute('aria-disabled') === 'true';
          this.button.textContent = current.querySelector('span')?.textContent.trim() || current.textContent.trim();
          const price = current.closest('product-info')?.querySelector('.price');
          if (price) this.querySelector('[data-sticky-price]').textContent = price.querySelector('.price__regular .price-item--regular')?.textContent.trim() || '';
        };
        this.observer = new MutationObserver(this.sync);
        this.observer.observe(this.target.closest('product-info'), { childList: true, subtree: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled'] });
        this.updateVisibility = () => {
          const distance = -this.target.getBoundingClientRect().bottom;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const progress = reducedMotion ? Number(distance > 0) : Math.min(1, Math.max(0, distance / 100));
          this.style.setProperty('--howl-purchase-reveal', String(progress));
          this.hidden = progress === 0;
        };
        this.onScroll = () => {
          if (this.visibilityFrame) return;
          this.visibilityFrame = requestAnimationFrame(() => { this.visibilityFrame = null; this.updateVisibility(); });
        };
        window.addEventListener('scroll', this.onScroll, { passive: true });
        window.addEventListener('resize', this.onScroll, { passive: true });
        this.intersection = new IntersectionObserver(this.updateVisibility);
        this.intersection.observe(this.target);
        this.sync();
        this.updateVisibility();
      }
      disconnectedCallback() { cancelAnimationFrame(this.visibilityFrame); window.removeEventListener('scroll', this.onScroll); window.removeEventListener('resize', this.onScroll); this.intersection?.disconnect(); this.observer?.disconnect(); this.button?.removeEventListener('click', this.activate); }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["howl-welcome-popup"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('howl-welcome-popup')) return;
    const cookieName = 'howl_welcome_session_v31';
    const readSession = () => {
      try {
        const value = document.cookie.split('; ').find(item => item.startsWith(cookieName + '='));
        if (!value) return null;
        const state = JSON.parse(decodeURIComponent(value.slice(cookieName.length + 1)));
        return typeof state.elapsed === 'number' && typeof state.shown === 'boolean' ? state : null;
      } catch (_) { return null; }
    };
    const writeSession = state => {
      try { document.cookie = cookieName + '=' + encodeURIComponent(JSON.stringify(state)) + '; Path=/; SameSite=Lax' + (location.protocol === 'https:' ? '; Secure' : ''); } catch (_) {}
    };
    class HowlWelcomePopup extends HTMLElement {
      connectedCallback() {
        this.dialog = this.querySelector('dialog');
        this.id = this.dataset.sectionId;
        this.form = document.getElementById('HowlNewsletter-' + this.id);
        this.section = this.form?.closest('.howl-welcome');
        if (!this.section || !this.dialog?.showModal || window.Shopify?.designMode) return;
        if (!readSession()) writeSession({elapsed: 0, through: 0, shown: false});
        if (!readSession() || readSession().shown) return;
        this.abort = new AbortController();
        const options = {signal: this.abort.signal};
        this.querySelector('.howl-offer-close').addEventListener('click', () => this.dialog.close(), options);
        this.querySelector('.howl-offer-later').addEventListener('click', () => this.dialog.close(), options);
        this.dialog.addEventListener('close', () => this.restore(), options);
        this.lastTick = Date.now();
        document.addEventListener('visibilitychange', () => { this.lastTick = Date.now(); }, options);
        window.addEventListener('howl:intro-state', () => { this.lastTick = Date.now(); }, options);
        window.addEventListener('pageshow', () => { this.lastTick = Date.now(); }, options);
        this.timer = setInterval(() => this.tick(), 500);
      }
      blocked() {
        const opening = document.querySelector('.howl-video-opening');
        const intro = document.documentElement.dataset.howlIntro;
        return document.hidden || Boolean(opening && opening.dataset.state !== 'complete') ||
          ['pending', 'active', 'revealing'].includes(intro) ||
          Boolean(document.querySelector('dialog[open], cart-drawer.active, menu-drawer details[open]')) ||
          Boolean(document.activeElement?.matches('input, textarea, select, [contenteditable="true"]'));
      }
      tick() {
        if (this.ticking || this.shown || !this.isConnected) return;
        this.ticking = true;
        const update = () => {
          const state = readSession();
          const now = Date.now();
          const previous = this.lastTick;
          this.lastTick = now;
          if (!state || state.shown) { clearInterval(this.timer); return; }
          if (this.blocked()) return;
          state.elapsed = Math.min(25000, state.elapsed + Math.min(1000, Math.max(0, now - Math.max(previous, state.through || 0))));
          state.through = now;
          if (state.elapsed >= 25000) state.shown = true;
          writeSession(state);
          if (state.shown) { clearInterval(this.timer); this.open(); }
        };
        const done = () => { this.ticking = false; };
        if (navigator.locks) navigator.locks.request(cookieName, update).then(done, done);
        else { try { update(); } finally { done(); } }
      }
      open() {
        if (this.shown || !this.isConnected || this.blocked()) return;
        this.shown = true;
        this.previousFocus = document.activeElement;
        this.anchor = document.createComment('howl-newsletter-position');
        this.section.before(this.anchor);
        this.querySelector('[data-offer-content]').append(this.section);
        document.documentElement.classList.add('howl-offer-open');
        this.dialog.showModal();
      }
      restore() {
        if (this.anchor?.isConnected) this.anchor.replaceWith(this.section);
        document.documentElement.classList.remove('howl-offer-open');
        if (this.previousFocus?.isConnected) this.previousFocus.focus({preventScroll: true});
      }
      disconnectedCallback() {
        clearInterval(this.timer);
        this.abort?.abort();
        if (this.dialog?.open) this.dialog.close();
        this.restore();
      }
    }
    customElements.define('howl-welcome-popup', HowlWelcomePopup);
  })();
  } catch(e) { console.error(e); }
})();

})();
